import z from 'zod/v4';
import { DefaultPresetSchema } from './default-preset-schema';
import type { PresetConfig } from './types';
import { createPresetSchema } from './utils';

/**
 * Visningstid i minuter: how long a new viewing lasts by default, per object
 * kind. Null means unset, and the viewing form falls back to 60 minutes.
 */
export const ListingViewingDurationDataSchema = z.object({
  apartment: z.number().int().positive().nullable(),
  industrialpremises: z.number().int().positive().nullable(),
});

export type ListingViewingDurationPresetData = z.infer<
  typeof ListingViewingDurationDataSchema
>;

export const V1Schema = createPresetSchema(
  '1',
  ListingViewingDurationDataSchema
);

export const LISTING_VIEWING_DURATION_PRESET_IDENTIFIER =
  'listing.viewingduration';
// Single preset, so one fixed key per owner
export const LISTING_VIEWING_DURATION_PRESET_KEY = 'default';

const ListingViewingDurationPresetSchema = z.object({
  ...DefaultPresetSchema.shape,
  context: z.literal(LISTING_VIEWING_DURATION_PRESET_IDENTIFIER),
  data: V1Schema,
});

export const ListingViewingDurationPreset = {
  identifier: LISTING_VIEWING_DURATION_PRESET_IDENTIFIER,
  currentSchema: ListingViewingDurationPresetSchema,
  currentVersion: '1',
  migrations: null,
  single: true,
} as const satisfies PresetConfig;
